import { AdminCompanyTabKeys } from "./keys";

export const englishValues = {
  [AdminCompanyTabKeys.adminCompanyTab_deleteCompanyTitle]: "Delete company?",
  [AdminCompanyTabKeys.adminCompanyTab_deleteCompanyContent]:
    "This will mark the company as deleted.",
  [AdminCompanyTabKeys.adminCompanyTab_deleteBtn]: "Delete",
  [AdminCompanyTabKeys.adminCompanyTab_deletedTag]: "deleted",
  [AdminCompanyTabKeys.adminCompanyTab_deletedSuccessMessage]:
    "Deleted company",
  [AdminCompanyTabKeys.adminCompanyTab_showDeleted]: "Show deleted",
};

export const malayValues = {
  [AdminCompanyTabKeys.adminCompanyTab_deleteCompanyTitle]: "Padam syarikat?",
  [AdminCompanyTabKeys.adminCompanyTab_deleteCompanyContent]:
    "Ini akan menandakan syarikat sebagai dipadam.",
  [AdminCompanyTabKeys.adminCompanyTab_deleteBtn]: "Padam",
  [AdminCompanyTabKeys.adminCompanyTab_deletedTag]: "dipadam",
  [AdminCompanyTabKeys.adminCompanyTab_deletedSuccessMessage]:
    "Syarikat dipadam",
  [AdminCompanyTabKeys.adminCompanyTab_showDeleted]: "Tunjuk dipadam",
};

export const chineseSimplifiedValues = {
  [AdminCompanyTabKeys.adminCompanyTab_deleteCompanyTitle]: "删除公司？",
  [AdminCompanyTabKeys.adminCompanyTab_deleteCompanyContent]:
    "这将把公司标记为已删除。",
  [AdminCompanyTabKeys.adminCompanyTab_deleteBtn]: "删除",
  [AdminCompanyTabKeys.adminCompanyTab_deletedTag]: "已删除",
  [AdminCompanyTabKeys.adminCompanyTab_deletedSuccessMessage]: "已删除公司",
  [AdminCompanyTabKeys.adminCompanyTab_showDeleted]: "显示已删除",
};

export const chineseTraditionalValues = {
  [AdminCompanyTabKeys.adminCompanyTab_deleteCompanyTitle]: "刪除公司？",
  [AdminCompanyTabKeys.adminCompanyTab_deleteCompanyContent]:
    "這將把公司標記為已刪除。",
  [AdminCompanyTabKeys.adminCompanyTab_deleteBtn]: "刪除",
  [AdminCompanyTabKeys.adminCompanyTab_deletedTag]: "已刪除",
  [AdminCompanyTabKeys.adminCompanyTab_deletedSuccessMessage]: "已刪除公司",
  [AdminCompanyTabKeys.adminCompanyTab_showDeleted]: "顯示已刪除",
};
